import type { ProjectTemplate } from "../types/ead-types.ts";

const CACHE_KEY = "ead-expui.templates-summary.v1";

export function loadCachedTemplateSummaries(): ProjectTemplate[] | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { templates?: ProjectTemplate[] };
    return Array.isArray(parsed?.templates) ? parsed.templates : null;
  } catch {
    return null;
  }
}

export function saveCachedTemplateSummaries(templates: ProjectTemplate[]): void {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ templates, savedAt: Date.now() }));
  } catch {
    /* ignore quota */
  }
}

/** Map lightweight list API row to a ProjectTemplate shell for the sidebar. */
export function templateFromListSummary(row: Record<string, unknown>): ProjectTemplate {
  const pfmNodeCount = Number(row.pfmNodeCount ?? row.pfm_node_count ?? 0);
  return {
    id: String(row.id || ""),
    name: String(row.name || ""),
    description: String(row.description || ""),
    exploreType: row.exploreType != null ? String(row.exploreType) : row.explore_type != null ? String(row.explore_type) : undefined,
    targetUrl: row.targetUrl != null ? String(row.targetUrl) : row.target_url != null ? String(row.target_url) : undefined,
    aiPrompt: "",
    totalTestSteps: Number(row.totalTestSteps ?? row.total_test_steps ?? 0),
    failedTestSteps: Number(row.failedTestSteps ?? row.failed_test_steps ?? 0),
    pfmNodes: [],
    pfmNodeCount: Number.isFinite(pfmNodeCount) ? pfmNodeCount : 0,
    createdAt: Number(row.createdAt ?? row.created_at ?? 0),
    createdBy: String(row.createdBy ?? row.created_by ?? ""),
    lastModifiedAt: Number(row.lastModifiedAt ?? row.last_modified_at ?? 0),
    lastModifiedBy: String(row.lastModifiedBy ?? row.last_modified_by ?? ""),
    canonicalPfmExecutionId:
      row.canonicalPfmExecutionId != null
        ? String(row.canonicalPfmExecutionId)
        : row.canonical_pfm_execution_id != null
          ? String(row.canonical_pfm_execution_id)
          : undefined,
    timeBudgetMinutes:
      row.timeBudgetMinutes != null
        ? Number(row.timeBudgetMinutes)
        : row.time_budget_minutes != null
          ? Number(row.time_budget_minutes)
          : undefined,
  };
}

export function templatePfmNodeCount(t: ProjectTemplate): number {
  if (typeof t.pfmNodeCount === "number" && Number.isFinite(t.pfmNodeCount)) return t.pfmNodeCount;
  return t.pfmNodes?.length ?? 0;
}
